module.exports = __webpack_public_path__ + "static/img/background.6121eeb7.svg";